import React from 'react';
import { Checkbox } from '../checkbox/Checkbox';
import { Option } from './Dropdown';

interface DropdownOptionProps {
  option: Option;
  isSelected: boolean;
  multiSelect: boolean;
  disabled: boolean;
  onSelect: (option: Option) => void;
}

export function DropdownOption({ option, isSelected, multiSelect, disabled, onSelect }: DropdownOptionProps) {
  const getOptionClasses = () => {
    const baseClassName = 'pdq-react-dropdown__item';
    const classes = [baseClassName];

    isSelected && classes.push(`${baseClassName}--selected`);
    multiSelect && classes.push('multiSelect');
    disabled && classes.push('disabled');
    return classes.join(' ');
  };

  const handleChange = () => {
    !disabled && onSelect(option);
  };

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    multiSelect ? e.stopPropagation() : handleChange();
  };

  return (
    <div className={getOptionClasses()} onClick={handleClick}>
      {multiSelect && <Checkbox checked={isSelected} onChange={handleChange} disabled={disabled} />}
      {option.customContent ? option.customContent : <span>{option.label}</span>}
    </div>
  );
}
